#import "../fragments/sales-document-fragment.graphql"

mutation UpdateQuoteProduct($input: QuoteProductsUpdateInput!) {
    quoteProductsUpdate(input: $input) {
        salesDocument {
            ...SalesDocumentFragment
        }
    }
}
